import type { QueryKey } from "@tanstack/react-query"

const ECoachGroupParticipantQueryKey: {
    ModuleById(params: { participantId: number; moduleId: number }): QueryKey
} = {
    ModuleById: (params: { participantId: number; moduleId: number }): QueryKey => [
        "GroupParticipant",
        "ModuleById",
        `participantId:${params.participantId}`,
        `moduleId:${params.moduleId}`
    ]
}

const ECoachGroupParticipantQueryUrl: {
    ModuleById(params: { participantId: number; moduleId: number }): string
} = {
    ModuleById: (params: { participantId: number; moduleId: number }): string =>
        `/api/modules/${params.moduleId}/results/${params.participantId}/`
}

export { ECoachGroupParticipantQueryKey, ECoachGroupParticipantQueryUrl }
